module.exports = __webpack_public_path__ + "img/2010 winteressen 014.f6704145.jpg";